import FormControl from "@material-ui/core/FormControl"
import MenuItem from "@material-ui/core/MenuItem"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import Paper from "@material-ui/core/Paper"
import Select from "@material-ui/core/Select"
import Typography from "@material-ui/core/Typography"
import React from "react"
import { Link } from 'react-router-dom'

import { FormHelperText } from "@material-ui/core"
import { signUpLimit, UT } from "../../Constants"
import CustomAlert from "../CustomAlert"
import { convertTimestampToReadableDate } from "../../utils"

const Zero = ({ handleChange, labelWidth, classes, userType, participantsOnly }) => {
    if (participantsOnly) {
        return (
            <div className={classes.bigContainer}>
                <Paper className={classes.paper}>
                    <div>
                        <div style={{ marginBottom: 16 }}>

                            <Typography color="error" variant="subtitle1">
                                <a href={UT[0].link} target="_blank" rel="noopener noreferrer">Participante, inscreva-se na <b>página de Inscrições Oficiais da Universidade Federal de Santa Catarina</b> a seguir</a>.
                            </Typography>
                            <br />
                        </div>
                        <div>
                            <Typography
                                style={{
                                    textTransform: "uppercase",
                                }}
                                color="secondary">
                                Tipo de Inscrição
                            </Typography>
                            <FormControl
                                variant="outlined"
                                className={classes.formControl}>
                                <Select
                                    aria-describedby="userType-helper"
                                    value={userType}
                                    onChange={handleChange}
                                    input={
                                        <OutlinedInput
                                            labelWidth={labelWidth}
                                            name="userType"
                                        />
                                    }>
                                    <MenuItem value={null}>
                                        <em>Selecione o tipo</em>
                                    </MenuItem>
                                    <MenuItem value={"1"}>Participante</MenuItem>
                                </Select>
                                <FormHelperText id="userType-helper">Selecione um tipo de Inscrição</FormHelperText>
                            </FormControl>
                        </div>
                    </div>
                </Paper>
            </div>

        );
    } else {
        return (
            <div className={classes.bigContainer}>
                <Paper className={classes.paper}>
                    <div>
                        <div>
                            <CustomAlert message="O Contech é APENAS para inscrição de Resumos. ANTES, você deve se inscrever COMO PARTICIPANTE no evento" />
                            <CustomAlert message={`Resumos podem ser submetidos de ${convertTimestampToReadableDate(signUpLimit.min, true) + " até " + convertTimestampToReadableDate(signUpLimit.max, true)}`} />
                            <Typography variant="subtitle1">
                                Para mais informações, acesse a <Link to="/mais?tab=como-fazer-minha-inscricao-no-evento">Aba Como fazer minha inscrição no evento?</Link>.
                            </Typography>
                            <br />
                        </div>
                        <div>
                            <Typography
                                style={{
                                    textTransform: "uppercase",
                                }}
                                color="secondary">
                                Tipo de Inscrição
                            </Typography>
                            <FormControl
                                variant="outlined"
                                className={classes.formControl}>
                                <Select
                                    aria-describedby="userType-helper"
                                    value={userType}
                                    onChange={handleChange}
                                    input={
                                        <OutlinedInput
                                            labelWidth={labelWidth}
                                            name="userType"
                                        />
                                    }>
                                    <MenuItem value={null}>
                                        <em>Selecione o tipo</em>
                                    </MenuItem>
                                    <MenuItem value={"2"}>Apresentador</MenuItem>
                                </Select>
                                <FormHelperText id="userType-helper">Selecione um tipo de Inscrição</FormHelperText>
                            </FormControl>
                        </div>
                    </div>
                </Paper >
            </div >
        );
    }
}
Zero.defaultProps = {
    participantsOnly: false
}
export default Zero;